module.exports = __webpack_public_path__ + "static/media/close-icon.8354033a.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/close-icon.svg
// module id = 634
// module chunks = 0 1